import { render } from "./take.vue?vue&type=template&id=6d56ca5d&scoped=true"
import script from "./take.vue?vue&type=script&lang=js"
export * from "./take.vue?vue&type=script&lang=js"

import "./take.vue?vue&type=style&index=0&id=6d56ca5d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6d56ca5d"

export default script